import MyProLayout from "../../../components/MyProLayout";

const Order = () => {
    return (
        <MyProLayout>

        </MyProLayout>
    )
}
export default Order